'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/wishlist'));
    processInclude(require('./product/pdpProductDetails'));
    processInclude(require('./components/plpAddToCart'));

    $('.carousel').carousel({
        interval: false
    });

    if (window.SitePreferences.SWIPERJS_ENABLED) {
        processInclude(require('./swiperInit'));
    } else {
        processInclude(require('./zoomInit'));
    }
});
